import React from 'react';
import { Link } from 'react-scroll';
import { Typewriter } from 'react-simple-typewriter';
import './HeroSection.css';

const HeroSection = () => {
  return (
    <section className="hero-section">
      <div className="container">
        <h1 className="hero-title">
          <Typewriter
            words={[
              'Impulsamos tu visión.',
              'Transformamos ideas en soluciones digitales.',
              'Tu socio en innovación tecnológica.',
            ]}
            loop={0} // 0 = infinito
            cursor
            cursorStyle="_"
            typeSpeed={70}
            deleteSpeed={50}
            delaySpeed={1000}
          />
        </h1>
        <p className="hero-subtitle">
          Desde estrategias innovadoras hasta herramientas personalizadas, ayudamos a potenciar tu negocio y alcanzar tus metas.
        </p>
        <div className="hero-cta">
          <Link
            to="services-section"
            smooth={true}
            duration={800}
            className="hero-btn"
          >
            Descubre más
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
